import { translationsDictionary } from '../../gatsby-generated/translationsDictionary'; // Import the pre-generated dictionary

const getTranslationString = (id, foldername, filename, language, values = {}) => {
  // Access the specific translation from the pre-generated dictionary
  const translations =
    translationsDictionary[language]?.[foldername]?.[filename] ||
    translationsDictionary['en']?.[foldername]?.[filename] || {};

  let translation = translations[id] || id;

  // Replace placeholders with provided values
  Object.keys(values).forEach((key) => {
    translation = translation.replace(`{${key}}`, values[key]);
  });

  return translation;
};

export default getTranslationString;
